<div class="chart-container" #chartParent>
  <svg class="multi-chart" [id]="'chart-container'" #chartContainer></svg>
  @if (noDataShown) {
    <h5>No Data Available</h5>
  }
</div>
